import { render, staticRenderFns } from "./AvatarsList.vue?vue&type=template&id=041d4147&scoped=true&"
import script from "./AvatarsList.vue?vue&type=script&lang=js&"
export * from "./AvatarsList.vue?vue&type=script&lang=js&"
import style0 from "./AvatarsList.vue?vue&type=style&index=0&id=041d4147&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d4147",
  null
  
)

export default component.exports